import Vue from "vue";
import App from "./App.vue";
import ErrorVue from "./Error.vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VeeValidate, { Validator } from "vee-validate";
import UUID from "vue-uuid";
import Cleave from "vue-cleave-component";
import VueHtmlToPaper from "vue-html-to-paper";
import { ServerTable, ClientTable } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import helpers from "./services/helpers";
Vue.prototype.$eventBus = new Vue();
// import store from "./store";
// import vuei18n from "./i18n";
// import CodeDiff from "v-code-diff";
// import router from "./router/router";
import VueHtml2Canvas from "vue-html2canvas";
import "regenerator-runtime";
import { inspect } from "@xstate/inspect";
import { getConfig, getDataConfig } from "./services/environment";

import "@fontsource/plus-jakarta-sans";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";

import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";

if(process.env.VUE_APP_INSPECT_MACHINE) {
    inspect({
        iframe: false,
    });
}
const printHtmlConfig = {
    name: "_blank",
    specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
    styles: [
        "./assets/sass/style.bundle.css",
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    ],
};
Vue.use(ServerTable, {}, false, "bootstrap4", "default");
Vue.use(ClientTable, {}, false, "bootstrap4", "default");
Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(UUID);
Vue.use(Cleave);
Vue.use(VueHtmlToPaper, printHtmlConfig);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
// Vue.use(CodeDiff);
Vue.use(VueHtml2Canvas);
Vue.component("downloadExcel", JsonExcel);
import "vue-multiselect/dist/vue-multiselect.min.css";

import id from "vee-validate/dist/locale/id";
Validator.localize("id", id);

Vue.config.productionTip = false;

// const i18n = new vuei18n();
import './assets/tailwind.generated.css';
getConfig()
    .then(async () => {
        // Import setelah getConfig berhasil
        const store = (await import("./store")).default;
        const vuei18n = (await import("./i18n")).default;
        const CodeDiff = (await import("v-code-diff")).default;
        const router = (await import("./router/router")).default;

        Vue.use(CodeDiff);

        const i18n = new vuei18n();

        Vue.i18n = i18n.internationalization();
        App.i18n = Vue.i18n;
        App.store = store;
        App.router = router;
        window.Vue = Vue;
        window.helpers = helpers;
        
        const loadingMonitor = Vue.observable({
            userName: "",
        });

        const response = await axios.get('/idp-login')

        Object.defineProperty(window, "userName", {
            get() {
                return loadingMonitor.userName;
            },

            set(value) {
                loadingMonitor.userName = value;
            },
        });

        new Vue({
            render: (h) => h(App),
        }).$mount("#app");
        
    })
    .catch(() => {
        new Vue({
            render: (h) => h(ErrorVue),
        }).$mount("#app");
    });
